import React, { useState } from "react";
import { Link } from "react-router-dom";
// import "./successfull.css";
import { useNavigate } from 'react-router-dom';



const UpdateSuccessfully = ({ type }) => {
  const [pin, setPin] = useState("pin")
  const navigate = useNavigate();

  const handleClick = () => {
    if (type === pin) {
      navigate("/");
    } else {
      navigate("/");
    }
  };

  return (
    <div className=" successful_preview_transprant_body ">
      <div className=" p-2 successful_preview_container shadow">
        {/* <img src="/images/Ellipse 208.svg" alt="" /> */}
        <img className="activityLoader" src="/gift/tick_mark.gif" alt="" />
        <span className=" my-4 successfully_message">
          {`Your ${type} updated successfully.`}
        </span>
        <button className="successfull_okay_btn" onClick={handleClick} >Okay</button>
      </div>
    </div>
  );
};

export default UpdateSuccessfully;
